import React from 'react'
import moment from 'moment'
import more from './images/twitter/twitter_more.svg'
import actions from './images/twitter/twitter_actions.svg'
import play from './images/twitter/twitter_play.svg'
import duration from './images/twitter/twitter_duration.svg'
import { LinkPreview } from '../shared'

export default function SocialTwitterPreview({
    account,
    startDate,
    content,
    images = [],
    foundLink = null,
    video = false
}) {
    const now = moment(startDate)

    const hashtagRegex = /#(\w+)/g
    content = content.replace(hashtagRegex, `<span style="color: #1D9BF0;">#$1</span>`)

    const linkRegex = /(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?/gi
    for (const link of content.split('<br />').join(' <br />').match(linkRegex) || []) {
        let str = link
        if (str.length > 23) str = str.substring(0, 23) + '...'
        content = content.replace(link, `<span style="color: #1D9BF0;">${str}</span>`)
    }
    return (
        <div
            style={{
                width: 480,
                backgroundColor: 'white',
                fontFamily: 'inter',
                padding: '12px 16px 0 16px',
                borderRadius: 8
            }}
        >
            <div style={{ display: 'flex' }}>
                <img src={account.image} style={{ borderRadius: '50%', height: 40, width: 40, marginRight: 12 }} />
                <div style={{ flexGrow: 1, display: 'block' }}>
                    {/* header */}
                    <div style={{ display: 'flex', fontSize: '15px' }}>
                        <div style={{ flexGrow: 1, display: 'flex' }}>
                            <div style={{ marginRight: 4, color: '#0F1419', fontWeight: 700, lineHeight: '20px' }}>
                                {account.name}
                            </div>
                            <div style={{ marginRight: 4, color: '#536471', fontWeight: 400, lineHeight: '20px' }}>
                                @{account.username}
                            </div>
                            <div style={{ marginRight: 4, color: '#536471', fontWeight: 400, lineHeight: '20px' }}>
                                .
                            </div>
                            <div style={{ marginRight: 4, color: '#536471', fontWeight: 400, lineHeight: '20px' }}>
                                {now.format('MMM DD')}
                            </div>
                        </div>
                        <img src={more} />
                    </div>

                    {/* content */}
                    <div
                        style={{
                            color: '#050505',
                            fontSize: '15px',
                            fontWeight: 400,
                            lineHeight: '20px',
                            marginBottom: 8,
                            wordBreak: 'break-all'
                        }}
                        dangerouslySetInnerHTML={{ __html: content }}
                    ></div>

                    {/* link preview */}
                    {!!foundLink && !images.length && <LinkPreview title={foundLink.title} image={foundLink.image} />}

                    {/* image */}
                    {images.length === 1 && (
                        <div style={{ position: 'relative' }}>
                            <img
                                src={images[0].url || images[0]}
                                style={{
                                    backgroundColor: '#e0e0e0',
                                    width: '100%',
                                    position: 'relative',
                                    justifyContent: 'center',
                                    borderRadius: 16,
                                    border: '1px solid #E1E8ED'
                                }}
                            />
                            {video && (
                                <>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            height: '100%',
                                            width: '100%',
                                            top: 0,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <img src={play} />
                                    </div>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            height: '100%',
                                            width: '100%',
                                            top: 0,
                                            display: 'flex',
                                            justifyContent: 'flex-start',
                                            alignItems: 'flex-end'
                                        }}
                                    >
                                        <img src={duration} style={{ margin: '12px 10px' }} />
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {images.length === 2 && (
                        // just split the images as background-image with divs to cover more area
                        <div style={{ display: 'flex', gap: 2, borderRadius: 14, overflow: 'hidden' }}>
                            {images.map((image, index) => (
                                <div
                                    key={index}
                                    style={{
                                        backgroundImage: `url(${image.url || image})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        width: '50%',
                                        height: 200
                                    }}
                                ></div>
                            ))}
                        </div>
                    )}

                    {images.length === 3 && (
                        // first image on left, 2 stacked on right
                        <div style={{ display: 'flex', gap: 2, borderRadius: 14, overflow: 'hidden' }}>
                            <div
                                style={{
                                    backgroundImage: `url(${images[0].url || images[0]})`,
                                    backgroundSize: 'cover',
                                    backgroundPositionX: 'center',
                                    backgroundPositionY: 'center',
                                    width: '50%',
                                    height: 200
                                }}
                            ></div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 2, width: '50%' }}>
                                <div
                                    style={{
                                        backgroundImage: `url(${images[1].url || images[1]})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        height: '50%'
                                    }}
                                ></div>
                                <div
                                    style={{
                                        backgroundImage: `url(${images[2].url || images[2]})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        height: '50%'
                                    }}
                                ></div>
                            </div>
                        </div>
                    )}

                    {images.length === 4 && (
                        // grid of 4
                        <div style={{ display: 'flex', gap: 2, borderRadius: 14, overflow: 'hidden' }}>
                            <div style={{ width: '50%', display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <div
                                    style={{
                                        backgroundImage: `url(${images[0].url || images[0]})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        height: 99
                                    }}
                                ></div>
                                <div
                                    style={{
                                        backgroundImage: `url(${images[1].url || images[1]})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        height: 99
                                    }}
                                ></div>
                            </div>
                            <div style={{ width: '50%', display: '  flex', flexDirection: 'column', gap: 2 }}>
                                <div
                                    style={{
                                        backgroundImage: `url(${images[2].url || images[2]})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        height: 99
                                    }}
                                ></div>
                                <div
                                    style={{
                                        backgroundImage: `url(${images[3].url || images[3]})`,
                                        backgroundSize: 'cover',
                                        backgroundPositionX: 'center',
                                        backgroundPositionY: 'center',
                                        height: 99
                                    }}
                                ></div>
                            </div>
                        </div>
                    )}

                    {/* footer */}
                    <img src={actions} />
                </div>
            </div>
        </div>
    )
}
